import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Gallery } from "./components/Gallery";
import { Clients } from "./components/Clients";
import { About } from "./components/About";
import { QuoteForm } from "./components/QuoteForm";
import { GoogleReview } from "./components/GoogleReview";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink min-h-screen overflow-x-clip">
      <div className="grain-overlay" />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Gallery />
        <Clients />
        <About />
        <QuoteForm />
        <GoogleReview />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
